import { IAppService } from '@modules/app/service/IAppService';
import { AppServiceFactory } from '@modules/app/service/AppServiceFactory';
import { IHistoryService } from '@modules/canvas/services/history/IHistoryService';
import { HistoryServiceFactory } from '@modules/canvas/services/history/HistoryServiceFactory';

import { Shortcut } from '../types';
import { IKeyMap } from './IKeyMap';


export class CanvasSetupKeyMap implements IKeyMap {
  private appSvc: IAppService;
  private historySvc: IHistoryService;
  public constructor() {
    this.appSvc = AppServiceFactory.getInstance().createAppService();
    this.historySvc = HistoryServiceFactory.getInstance().createHistoryService();
  }

  handleKeyPress(shortcut: Shortcut): void {
    switch (shortcut.code) {
      case 'KeyV': {
        this.appSvc.activateTool('cursor');
        break;
      }

      case 'KeyH': {
        this.appSvc.activateTool('pan');
        break;
      }

      case 'KeyY': {
        if (shortcut.ctrl) {
          this.historySvc.redo();
          break;
        }
        break;
      }

      case 'KeyZ': {
        if (shortcut.ctrl) {
          this.historySvc.undo();
          break;
        }
        break;
      }

      default:
        break;
    }
  }
}
